// UTF-16 offsets match Java and @ mention ranges. No message HTML is rendered.
export const textColors = [
  ['红色','#c43d16'],['橙色','#b96b00'],['绿色','#008a35'],['金色','#a08000'],
  ['紫色','#8e44ad'],['蓝色','#287fa3'],['玫红','#b83270'],['橄榄绿','#587500'],
];
const boundary=(text,index)=>index===0||index===text.length||!/[\uD800-\uDBFF]/.test(text[index-1])||!/[\uDC00-\uDFFF]/.test(text[index]);
const colors = new Set(textColors.map(([,color])=>color));
export function normalizeStyles(text,raw) {
  let spans=raw;
  if(typeof spans==='string'){try{spans=JSON.parse(spans)}catch{return []}}
  if(!Array.isArray(spans)||spans.length>256)return [];
  let end=0;const result=[];
  for(const span of [...spans].sort((a,b)=>(a?.start||0)-(b?.start||0))){
    if(!span||!Number.isInteger(span.start)||!Number.isInteger(span.end)||span.start<end||span.end<=span.start||span.end>text.length||!boundary(text,span.start)||!boundary(text,span.end))return [];
    const color=typeof span.color==='string'?span.color.toLowerCase():null;
    if(color&&!colors.has(color))return [];
    const style={start:span.start,end:span.end};
    if(span.bold===true)style.bold=true;if(color)style.color=color;
    if(style.bold||style.color)result.push(style);end=span.end;
  }
  return result;
}
export function styleSegments(segments,raw,text,keyword='') {
  const spans=normalizeStyles(text,raw),hits=[],key=(keyword||'').trim().toLowerCase();
  if(key){const lower=text.toLowerCase();let at=0;while((at=lower.indexOf(key,at))>=0){hits.push({start:at,end:at+key.length});at+=key.length}}
  const result=[];let offset=0;
  for(const segment of segments){
    const end=offset+segment.text.length,bounds=new Set([offset,end]);
    for(const span of [...spans,...hits])for(const edge of [span.start,span.end])if(edge>offset&&edge<end)bounds.add(edge);
    const sorted=[...bounds].sort((a,b)=>a-b);
    for(let i=0;i<sorted.length-1;i++){
      const from=sorted[i],to=sorted[i+1],style=spans.find(s=>s.start<=from&&s.end>=to);
      result.push({...segment,text:segment.text.slice(from-offset,to-offset),style:{...(style?.bold?{fontWeight:'700'}:{}),...(style?.color?{color:style.color}:{})},hit:hits.some(h=>h.start<=from&&h.end>=to)});
    }
    offset=end;
  }
  return result;
}
